module.exports = __webpack_public_path__ + "static/media/Wipes.4bb6d2da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Products/Wipes.png
// module id = 318
// module chunks = 0